import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { IForm } from "@/types";
import { useFormContext } from "react-hook-form";

interface Props {
    field: IForm["fields"][0];
    admin?: boolean; // Optionally handle admin mode
    setSelectedField?: (field: IForm["fields"][0]) => void; // Allow setting selected field
    value?: string; // Optional value prop
    className?: string;
}

export const TextArea = ({
    field,
    admin,
    setSelectedField,
    value,
    className,
}: Props) => {
    const formContext = useFormContext();
    const register = admin ? () => {} : formContext.register;
    const errors = admin ? {} : formContext.formState.errors;

    return (
        <div
            className={cn("flex w-full flex-col gap-1", className)}
            onClick={() => {
                if (admin && setSelectedField) {
                    setSelectedField(field); // Open item when admin clicks
                }
            }}
        >
            <Label variant="toggle" className="!text-form-primary-text-color">
                {field.question || (
                    <span className="text-form-primary-text-color/70">
                        Question goes here...
                    </span>
                )}
                {field.required && (
                    <span className="text-form-primary-color">*</span>
                )}
            </Label>
            {field.description && (
                <Label
                    variant="subtoggle"
                    className="text-form-primary-text-color/70"
                >
                    {field.description}
                </Label>
            )}

            {/* Textarea Field */}
            <Textarea
                {...(!admin ? register(field.id) : {})} // Skip form validation if admin
                variant="card"
                placeholder={field.placeholder || "Answer..."}
                className="placeholder:text-form-primary-text-color/50 border-form-primary-color/30 focus:border-form-primary-color text-form-primary-text-color focus-visible:border-form-primary-color h-[250px] resize-none overflow-auto border bg-transparent transition-colors duration-300"
                readOnly={admin} // Allow click but prevent typing if admin
                value={value} // Bind the value prop to the textarea
            />

            {/* Validation Error Message (only for non-admin users) */}
            {!admin && errors?.[field.id] && (
                <p className="text-sm text-red-500">
                    {errors[field.id]?.message?.toString()}
                </p>
            )}
        </div>
    );
};
